import React from "react";
import parse from "html-react-parser";
import "./LongLabel.scss";

const allowed = new Set(["b", "strong", "i", "em", "u", "a", "br"]);

const LongLabel = ({ label, noDots, className = "", ...rest }) => {
  let content = label;

  if (typeof label === "string" && /<[^>]+>/.test(label)) {
    content = parse(label, {
      replace: (node) => {
        if (node.type === "tag") {
          if (!allowed.has(node.name))
            return (
              <>
                {node.children?.map((c, i) => (
                  <React.Fragment key={i}>{c.data || ""}</React.Fragment>
                ))}
              </>
            );
          if (node.name === "a") {
            return (
              <a
                href={node.attribs?.href}
                target="_blank"
                rel="noopener noreferrer"
              >
                {node.children?.map((c, i) => (
                  <React.Fragment key={i}>{c.data || ""}</React.Fragment>
                ))}
              </a>
            );
          }
        }
      },
    });
  }

  return (
    <label className={`LongLabel ${className}`} {...rest}>
      {content}
      {!noDots && " :"}
    </label>
  );
};

export default LongLabel;
